// extracted by mini-css-extract-plugin
export default {"gapMax":"64px","gapMaxSm":"16px"};